import React, { useState } from 'react';
import { IntegrationItem } from '../../../../../shared/ui';
import { IconMap } from '../../../../../shared/sprite';
import { useDispatch, useSelector } from 'react-redux';
import { teamsModel } from '../../../../teams';
import { FathomIntegrationModal } from './FathomIntegrationModal';
import { fathomModel } from '../../../../../entities/fathom';
import { DisconnectFathomConfirmationModal } from './DisconnectFathomConfirmationModal';

export const FathomIntegration: React.FC = () => {
  const [isIntegrationModalOpen, setIntegrationModalOpen] = useState(false);
  const [isConfirmationModalOpen, setConfirmationModalOpen] = useState(false);

  const currentTeam = useSelector(
    teamsModel.selectors.selectCurrentTeamWithError
  );

  const isFathomConnected = currentTeam.isFathomConnected;

  const dispatch = useDispatch();

  const handleDisconnectFromFathom = () => {
    dispatch(
      fathomModel.actions.disconnectFromFathom({
        cb: () => setConfirmationModalOpen(false),
      })
    );
  };

  return (
    <>
      <FathomIntegrationModal
        isOpen={isIntegrationModalOpen}
        onClose={() => setIntegrationModalOpen(false)}
      />
      <DisconnectFathomConfirmationModal
        isOpen={isConfirmationModalOpen}
        onClose={() => setConfirmationModalOpen(false)}
        onConfirm={handleDisconnectFromFathom}
      />
      <IntegrationItem
        icon={IconMap.FathomLg}
        title="Fathom"
        description="Unlock the potential of Fathom by integrating it with advanced AI Distribute features. This integration enables you to effortlessly generate follow-up pages after your calls."
        buttonText={isFathomConnected ? 'Disconnect' : 'Connect'}
        onClick={() =>
          isFathomConnected
            ? setConfirmationModalOpen(true)
            : setIntegrationModalOpen(true)
        }
        isDisconnect={isFathomConnected}
      />
    </>
  );
};
